export default {
  // userInfo:{},//用户信息
  // token:null
  userInfo: {
    commission: null,
    consume_money: null,
    consume_oil_money: null,
    created_at: "2023-03-13T01:51:23.000000Z",
    diesel_money: null,
    head_portrait: "https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eqdoSp2I8IkKciciaFFA9EfjOjrYjz9sbH1e2WP6xBWLJfoj4rdoZrX1vqFnsHvlD82prEzMn4T3Ncw/132",
    id: 63614,
    integral: 0,
    is_sign: 0,
    nickname: "大雄",
    open_id: "oxM_e1QRkdEZbbqcxE6Yd81NhSL4",
    petrol_money: null,
    phone: "18611348527",
    qr_img: "http://xjddi.conjure.net.cn/qrcodes/oxM_e1QRkdEZbbqcxE6Yd81NhSL463303.png",
    sub_count: 0
  },
  token:'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvYXBpLnhqZGRqeXouY25cL2FwaVwvb2F1dGhfY2FsbGJhY2siLCJpYXQiOjE3NjgxOTYzOTQsImV4cCI6MTc3NTk3MjM5NCwibmJmIjoxNzY4MTk2Mzk0LCJqdGkiOiJ2RDFhM1U5dU5uNjFuNDVDIiwic3ViIjo2MzYxNCwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyJ9.CswBDcAbzOItl94KyqCHC4RX0eXDrjKTIc7Z5dvCiKI'
}



// WEBPACK FOOTER //
// ./src/store/user/state.js